<template>
    <div class="drop-down-filter">
        <el-row type="flex" justify="left">
            <el-col :xs="{span: 24}" :sm="{span: 24}">

                <el-row type="flex" justify="center">
                    <el-col :xs="{span: 1}" :sm="{span: 2}">
                        <div style="height: 1px;"></div>
                    </el-col>

                    <el-col :xs="{span: 22}" :sm="{span: 20}">
                        <!-- collapse-tags -->
                        <el-select
                                :class="'retro retro-search retro-selection'"
                                :disabled="isLoading"
                                v-model="selected"
                                filterable
                                multiple
                                @change="onChange({ selected })"
                                :clearable="true"
                                :placeholder="placeholder || 'Filter'">
                            <el-option
                                    v-for="element in data"
                                    :key="element._id"
                                    :label="element.name"
                                    :value="element._id">
                                <span style="float: left"> <img :src="icons[element.avatar]" class="selection-icon"></span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ element.name }}</span>
                            </el-option>
                        </el-select>
                    </el-col>

                    <el-col :xs="{span: 1}" :sm="{span: 2}">
                        <div style="height: 1px;"></div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  name: 'DropDownFilter',
  components: {},
  props: ['isLoading', 'onChange', 'data', 'icons', 'placeholder'],
  mounted () {},
  data () {
    return {
      selected: []
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.drop-down-filter {
    .retro-search {
        margin-left: 0px;
        max-width: 400px;
        width: 90%;
    }

    .retro-selection {
        margin-bottom: 1em;

        .el-input__inner {
            border-left-width: 1px;
        }

        .el-tag.el-tag--info {
            color: purple;
            font-size: $font-size-small;
            padding: 1px;
            padding-left: 3px;
            padding-right: 5px;
        }

        .el-tag .el-icon-close {
            margin-left: -6px;
            color: purple;
        }
    }
}

.selection-icon {
    max-width: 20px;
}
</style>
